import { all } from 'redux-saga/effects'

//public
import accountSaga from './auth/register/saga';
import loginSaga from './auth/login/saga';
import forgetSaga from './auth/forgetpwd/saga';
import rolesSaga from './auth/roles/saga';
import LayoutSaga from './layout/saga';

//client
// import customerData from './customer_data/saga';
// import offerPackageSaga from './offer_package/saga';

//administration
import portfolioSaga from './portfolio/saga';
import offerSaga from './offers/saga';
import tariffSaga from './tariff/saga';
import optionSaga from './option/saga';
import fileSaga from './files/saga';
import reportSaga from './report/saga';
import priceListSaga from './price_list/saga';

// gui
import hardwareSaga from './hardware/saga';
import calcWizardSaga from './calculator/saga';

import notificationSaga from './notifications/saga';
import maintenanceSaga from './maintenance/saga';

export default function* rootSaga() {
    yield all([
        
        //public
        accountSaga(),
        loginSaga(),
        forgetSaga(),
        rolesSaga(),
        LayoutSaga(),

        //client
        //customerData(),
        // offerPackageSaga(),
        portfolioSaga(),
        offerSaga(),
        tariffSaga(),
        optionSaga(),

        // files
        fileSaga(),
        // dropdowns
        hardwareSaga(),
        reportSaga(),
        // calculator wizard
        calcWizardSaga(),
        notificationSaga(),
        maintenanceSaga(),
        priceListSaga()
    ])
}
